// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_67955","container":"d6495","slides":"_6725f","slide":"c09de","next-button":"c7ee7","nextButton":"c7ee7","prev-button":"_2070d","prevButton":"_2070d"};